import { CancelTokenSource } from 'axios';
import {
  PatientMergeRequest,
  PatientMergeResponse,
  PatientMergingSearchRequest,
  PatientMergingSearchResponse
} from 'ts-types/api.types';
import axios from './http';

const {REACT_APP_API_BASE_URL: baseUrl} = process.env;
const apiUri = `${baseUrl}/api/patients-merging`;

export const searchPatientMerging = (
    source: CancelTokenSource,
    searchData: Partial<PatientMergingSearchRequest>): Promise<PatientMergingSearchResponse> => {

  return axios
      .post(`${apiUri}/patientSearch`, searchData, {cancelToken: source.token})
      .then((response) => response.data);
};

export const searchDuplicatePatient = (
    source: CancelTokenSource) => {

  return axios
      .get(`${apiUri}/duplicateSearch`, {cancelToken: source.token})
      .then((response) => response.data);
}

export const mergePatients = (patientMergeRequest: Partial<PatientMergeRequest>,
    source: CancelTokenSource): Promise<PatientMergeResponse> => {

  return axios
      .post(`${apiUri}/patientMerge`, patientMergeRequest, {cancelToken: source.token})
      .then((response) => response.data);
}

export const copyInsuranceFromMaster = (patientMergeRequest: Partial<PatientMergeRequest>,
                              source: CancelTokenSource): Promise<PatientMergeResponse> => {

  return axios
      .post(`${apiUri}/copyInsurance`, patientMergeRequest, {cancelToken: source.token})
      .then((response) => response.data);
}
